<template>
    <div class="container wrapper">
        <div class="split">
            <div id="answers" v-for="(answer, index) in state.summaryAnswers" :key="index">
                <h3>{{ state.answerTitles[answer.id] }}</h3>
                <img src="../assets/pen.png" width="15" @click="editAnswer(index)">
                <p>{{ answer.comment }}</p>
            </div>
            <SummaryAnswer
                :class="{ hidden: state.progress === 4 }"
                :title="state.answerTitles[state.progress]"
                :progress="state.progress"
                :comment="state.answerComment"
                @answer="saveAnswer" />
            <div v-if="state.progress === 4" id="ready">
                <h2>Hienoa! Jos olet valmis, jatka seuraavaan vaiheeseen.<br> Voit halutessasi vielä muokata antamiasi vastauksia.</h2>
                <button @click="finishPhase">Seuraavaan vaiheeseen</button>
            </div>
        </div>
        <div class="split">
            <div id="trigendaBoard">
                <div class="cardDiv">
                    <div id="triangleImage">
                        <h1 id="descBottom">{{ state.goalCard.description }}</h1>
                    </div>
                </div>
                <div id="secondCardRow">
                    <div class="cardDiv">
                        <div id="triangleImage">
                            <h1 id="descBottom">{{ state.assetOneCard.description }}</h1>
                        </div>
                    </div>
                    <div class="cardDiv">
                        <div id="triangleImage">
                            <h1 id="descBottom">{{ state.challengeCard.description }}</h1>
                        </div>
                    </div>
                    <div class="cardDiv">
                        <div id="triangleImage">
                            <h1 id="descBottom">{{ state.assetTwoCard.description }}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Card from './Card.vue';
import { reactive } from 'vue';
import SummaryAnswer from './SummaryAnswer.vue';

export default {
    name: "Summary",
    props: {
        msg: String,
    },
    components: {
        Card,
        SummaryAnswer
    },
    setup(props, { emit }) {
        const state = reactive({
            // Index of the current answer
            progress: 0,
            // Title for SummaryAnswer component, array index based on progress
            answerTitles: ['Keskustelun pääsisällöt, mistä asioista keskusteltiin:',
                'Keskustelussa nousseet tavoitteet ja keinot niiden saavuttamiseksi:',
                'Keskustelun oivallukset:',
                'Aiheet, joista voi vielä jatkaa:'
            ],
            // Prop to SummaryAnswer, sets the comment for the textbox
            answerComment: '',

            /**
             * Answer objects in the array, Id property is based on progress and comment is
             * based on given answer in the SummaryAnswer component
             */
            summaryAnswers: [],
            // Cards based on placement in Phase 2
            goalCard: null,
            challengeCard: null,
            assetOneCard: null,
            assetTwoCard: null
        });

        const cardArray = JSON.parse(localStorage.getItem("cardArray"));

        state.goalCard = cardArray.find(card => card.phase2selection === 'Tavoite');
        state.challengeCard = cardArray.find(card => card.phase2selection === 'Haaste');
        state.assetOneCard = cardArray.find(card => card.phase2selection === 'Voimavara1');
        state.assetTwoCard = cardArray.find(card => card.phase2selection === 'Voimavara2');


        const saveAnswer = (answer) => {
            const oldAnswerIndex = state.summaryAnswers.findIndex(answer => answer.id === state.progress);

            /**
             * Check if there is already given comment on current answer. This is possible if user is
             * editing an already existing answer.
             * if old comment exists, replace it. Otherwise push a new answer to summaryAnswers
             */
            if (oldAnswerIndex >= 0)
                state.summaryAnswers[oldAnswerIndex].comment = answer;
            else
                state.summaryAnswers.push({ id: state.progress, comment: answer });

            localStorage.setItem('summaryAnswers', JSON.stringify(state.summaryAnswers));

            /**
             * Increases progress as long as there is not given answer in progress index.
             * This way we get always to the latest not-yet-given answer after editing an old comment.
             * Or to end of the Summary if all answers are already given
             */
            while (state.summaryAnswers[state.progress])
                state.progress++;

            state.answerComment = '';
        }

        const editAnswer = (index) => {
            state.progress = index;
            state.answerComment = state.summaryAnswers[index].comment;
        }

        const finishPhase = () => {
            emit('phasecomplete');
        }

        return { state, saveAnswer, editAnswer, finishPhase };
    },
    emits: ['phasecomplete'],
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* Card CSS starts */
    #answers {

    }
    #descBottom, #descLeft, #descRight {
        font-size: 16px;
        font-weight: normal;
    }

    #triangleImage {
        position: relative;
        background-image: url('../assets/card.png');
        background-size: cover;
        margin: 0px;
        padding: 0px;
        left: 0px;
        width: 210px;
        height: 182px;
        display: inline-block;
        cursor: default;
        user-select: none;
        transform: scale(0.7);
    }

    #descBottom {
        position: relative;
        top: 143px;
    }

    #descLeft {
        position: relative;
        transform: rotate(120deg);
        top: 70px;
        left: -40px;
    }

    #descRight {
        position: relative;
        transform: rotate(240deg);
        top: 45px;
        left: 39px;
    }

    /* Card CSS ends */

    .wrapper {
        display: flex;
        height: 90vh;
    }

    .split {
        width: 50%;
        height: 91.3vh;
        justify-content: center;
        margin: auto 0;
    }

    .split:nth-child(1) {
        background-color: var(--left);
        overflow-y: scroll;
    }

    .split:nth-child(2) {
        background-image: url('../assets/tausta_blue.jpg');
        background-size: cover;
        background-repeat: no-repeat;
    }
    .split.split:nth-child(2) .content {
        margin-top: 170px;
    }
    .hidden {
        display: none;
    }

    #answers {
        width: 70%;
        margin: 20px auto;
        text-align: left;
    }

    #answers h3 {
        margin-bottom: 5px;
        margin-top: 5px;
        width: 90%;
        display: inline-block;
    }

    .cardDiv {
        width: 100%;
    }

    img:hover {
        transform: scale(1.1);
        cursor: pointer;
    }

    .choice{
        width: 80%;
        height: 80%;
    }
    .choice > img{
        width: 80%;
    }
    .card {
        width: 100%;
    }
    p {
        margin:0;
    }
    #secondCardRow {
        display: flex;
        width: 460px;
    }
    #tips{
        text-align:left;
        float:right;
        margin-top: 5em;
    }

    #decks{
        display: inline-flex;
    }
    #ChoiceButtons{
        margin-top: 15em;
    }

    #trigendaBoard{
        background-image: url('../assets/Alusta_tumma.png');
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        width: 459px;
        height: 400px;
        margin: 30px auto;
        top: 15%;
        display: flex;
        flex-wrap: wrap;
    }

    .triangle2 {
        background-color: white;
    }

    .trigendaBoard {
        position: relative;
    }

    #triangleImage:nth-child(1) {
        margin: 0 auto;
        bottom: 5px;
    }

    #secondCardRow .cardDiv:nth-child(1) {
        position: relative;
        top: 10px;
        left: 2px;
    }

    .cardDiv:nth-child(2) {
        position: relative;
        transform: rotate(180deg);
        right: 84px;
        bottom: 15px;
    }

    .cardDiv:nth-child(2) #descBottom {
        transform: rotate(180deg);
    }

    .cardDiv:nth-child(3) {
        position: relative;
        right: 173px;
        top: 10px;
    }

    @media only screen and (max-width: 600px) {
        .wrapper {
            flex-direction: column;
        }

        .split {
            width: 100%;
        }

        .temporary {
            display: none;
        }

        #trigendaBoard {
            top: 0;
        }
    }

    @media only screen and (max-width: 400px) {
        #trigendaBoard {
            transform: scale(0.6);
            left: -13vw;
        }

        .split:nth-child(2) {
            height: 50vh;
        }
    }
</style>
